import type { ContactPageLocaleContent } from '../types'

export const contactPageEs: ContactPageLocaleContent = {
  title: 'Contacto - Toolvance',
  description: 'Contacta con Toolvance.',
  metadata: {
    ogTitle: 'Contacto - Toolvance',
    ogDescription: 'Contacta con Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Contacto',
    intro: '¿Tienes una pregunta, encontraste un error o quieres sugerir una calculadora?',
    emailPrefix: 'Escríbenos a:',
  },
}
